import { ActionKind, ScannedCode } from "./Action";
import { SystemInformation } from "./Config";
import { Order, OrderInsights } from "./Order";
import { Wrap } from "./Wrap";
import { WrapRootState } from "../components/state/Common";
import { RootStateKind } from "../components/state/StateProvider";

export type DateRange = {
    from: string;
    to: string;
};

type BackToOperatorModeMenu = Wrap<ActionKind.BackToOperatorModeMenu>;

type ScanOperatorBadge = Wrap<
    ActionKind.ScanOperatorBadge,
    { scannedBadge: ScannedCode }
>;

type LoadMoreOrders = Wrap<
    ActionKind.LoadMoreOrders,
    { dateRange: DateRange; offset: number }
>;

type ShowOrders = Wrap<ActionKind.ShowOrders, { dateRange: DateRange }>;

export type InsightsGroupBy = "scoId" | "category";

type ShowInsights = Wrap<
    ActionKind.ShowInsights,
    { dateRange: DateRange; groupBy: InsightsGroupBy }
>;

type ShowHardware = Wrap<ActionKind.ShowHardware>;

type ShowSystemInformation = Wrap<ActionKind.ShowSystemInformation>;

type ShowConfiguration = Wrap<ActionKind.ShowConfiguration>;

type PaymentDeviceLogin = Wrap<ActionKind.PaymentDeviceLogin>;

type ProbePaymentTerminal = Wrap<ActionKind.ProbePaymentTerminal>;

type UpdatePaymentDeviceIp = Wrap<
    ActionKind.UpdatePaymentDeviceIp,
    { ip: string }
>;

export enum OperatorSubStateKind {
    Configuration = "configuration",
    Hardware = "hardware",
    Idle = "idle",
    Insights = "insights",
    Orders = "orders",
    SystemInformation = "systemInformation"
}

export type Operator = WrapRootState<
    typeof RootStateKind.Operator,
    {
        subState:
            | Wrap<OperatorSubStateKind.Idle>
            | Wrap<
                  OperatorSubStateKind.Orders,
                  {
                      dateRange: DateRange;
                      orders: Order[];
                      totalCount: number;
                      offset: number;
                  }
              >
            | Wrap<
                  OperatorSubStateKind.Insights,
                  {
                      dateRange: DateRange;
                      groupBy: ShowInsights["groupBy"];
                      insights: OrderInsights;
                  }
              >
            | Wrap<OperatorSubStateKind.Hardware>
            | Wrap<
                  OperatorSubStateKind.SystemInformation,
                  {
                      systemInformation: SystemInformation;
                  }
              >
            | Wrap<OperatorSubStateKind.Configuration>;
    }
>;

export type OperatorAction =
    | BackToOperatorModeMenu
    | ScanOperatorBadge
    | ShowOrders
    | LoadMoreOrders
    | ShowInsights
    | ShowHardware
    | ShowSystemInformation
    | ShowConfiguration
    | PaymentDeviceLogin
    | ProbePaymentTerminal
    | UpdatePaymentDeviceIp;
